import { Urls } from "../Urls";
import { IS_PROD } from "../Components/Constants";
import axios from "axios";

const FROM_EMAIL = "connect@logisticsnow.in";

export const INTERNAL_RECIPIENTS = IS_PROD ? [
  "connect@logisticsnow.in",
  "raj@logisticsnow.in",
  "radhika@logisticsnow.in",
  "radhika@lorri.ai",
  "associate@logisticsnow.in",
  "sales@thelogisticsnow.com",
  "sales@lorri.ai",
] : ["tech@thelogisticsnow.com", 
  "unnati@thelogisticsnow.com"];

export const buildPayload = ({ to, subject, content }) => ({
  from_email: FROM_EMAIL,
  user_type: "company",
  subject,
  to_email: to,
  content,
  mail_status: "Pending",
  activity: "Email Request",
  cc: [],
  type : "superlaunch",
  screen : "lorri.ai"
});

export const sendMail = (payload) => axios.post(Urls.log, payload);

export const sendMailToList = (recipients, { subject, content }) =>
  Promise.all(
    recipients.map((to) => sendMail(buildPayload({ to, subject, content })))
  );

// --- Demo Request: internal team notification ---
export const buildDemoInternalContent = (userInput) => `
<!DOCTYPE html>
<html>
<body style="font-family: Arial, sans-serif; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
  <div style="background-color: #393185; padding: 20px 24px; border-radius: 6px 6px 0 0;">
    <h2 style="color: #ffffff; margin: 0; font-size: 20px;">New Demo Request — LoRRI</h2>
  </div>
  <div style="border: 1px solid #e0e0e0; border-top: none; border-radius: 0 0 6px 6px; padding: 24px;">
    <table style="width: 100%; border-collapse: collapse;">
      <tr>
        <td style="padding: 10px 0; border-bottom: 1px solid #f0f0f0; width: 40%; color: #666; font-size: 14px;">Name</td>
        <td style="padding: 10px 0; border-bottom: 1px solid #f0f0f0; font-size: 14px; font-weight: 600;">${userInput.name || "—"}</td>
      </tr>
      <tr>
        <td style="padding: 10px 0; border-bottom: 1px solid #f0f0f0; color: #666; font-size: 14px;">Company</td>
        <td style="padding: 10px 0; border-bottom: 1px solid #f0f0f0; font-size: 14px; font-weight: 600;">${userInput.company_name || "—"}</td>
      </tr>
      <tr>
        <td style="padding: 10px 0; border-bottom: 1px solid #f0f0f0; color: #666; font-size: 14px;">Designation</td>
        <td style="padding: 10px 0; border-bottom: 1px solid #f0f0f0; font-size: 14px; font-weight: 600;">${userInput.designation || "—"}</td>
      </tr>
      <tr>
        <td style="padding: 10px 0; border-bottom: 1px solid #f0f0f0; color: #666; font-size: 14px;">Email</td>
        <td style="padding: 10px 0; border-bottom: 1px solid #f0f0f0; font-size: 14px; font-weight: 600;"><a href="mailto:${userInput.email}" style="color: #393185;">${userInput.email}</a></td>
      </tr>
      <tr>
        <td style="padding: 10px 0; border-bottom: 1px solid #f0f0f0; color: #666; font-size: 14px;">Contact Number</td>
        <td style="padding: 10px 0; border-bottom: 1px solid #f0f0f0; font-size: 14px; font-weight: 600;">${userInput.contact_number || "—"}</td>
      </tr>
      <tr>
        <td style="padding: 10px 0; border-bottom: 1px solid #f0f0f0; color: #666; font-size: 14px;">Heard From</td>
        <td style="padding: 10px 0; border-bottom: 1px solid #f0f0f0; font-size: 14px; font-weight: 600;">${userInput.heardFrom || "—"}</td>
      </tr>
      <tr>
        <td style="padding: 10px 0; color: #666; font-size: 14px;">Newsletter</td>
        <td style="padding: 10px 0; font-size: 14px; font-weight: 600;">${userInput.check ? "Yes" : "No"}</td>
      </tr>
    </table>
  </div>
  <p style="font-size: 12px; color: #999; margin-top: 16px;">This email was automatically generated from the LoRRI demo request form.</p>
</body>
</html>`.trim();

// --- Demo Request: user confirmation ---
export const buildDemoUserContent = (userInput) => `
<!DOCTYPE html>
<html>
<body style="font-family: Arial, sans-serif; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
  <div style="background-color: #393185; padding: 20px 24px; border-radius: 6px 6px 0 0;">
    <h2 style="color: #ffffff; margin: 0; font-size: 20px;">Your Demo Request is Confirmed — LoRRI</h2>
  </div>
  <div style="border: 1px solid #e0e0e0; border-top: none; border-radius: 0 0 6px 6px; padding: 24px;">
    <p style="font-size: 15px; margin: 0 0 16px;">Hi ${userInput.name || "there"},</p>
    <p style="font-size: 15px; margin: 0 0 16px;">
      Thank you for requesting a demo of <strong>LoRRI</strong>. We've received your details and our team will reach out to you shortly to confirm the meeting.
    </p>
    <table style="width: 100%; border-collapse: collapse; margin-bottom: 16px;">
      <tr>
        <td style="padding: 10px 0; border-bottom: 1px solid #f0f0f0; width: 40%; color: #666; font-size: 14px;">Name</td>
        <td style="padding: 10px 0; border-bottom: 1px solid #f0f0f0; font-size: 14px; font-weight: 600;">${userInput.name || "—"}</td>
      </tr>
      <tr>
        <td style="padding: 10px 0; border-bottom: 1px solid #f0f0f0; color: #666; font-size: 14px;">Company</td>
        <td style="padding: 10px 0; border-bottom: 1px solid #f0f0f0; font-size: 14px; font-weight: 600;">${userInput.company_name || "—"}</td>
      </tr>
      <tr>
        <td style="padding: 10px 0; color: #666; font-size: 14px;">Email</td>
        <td style="padding: 10px 0; font-size: 14px; font-weight: 600;">${userInput.email}</td>
      </tr>
    </table>
    <p style="font-size: 14px; color: #555; margin: 0;">
      If you have any questions in the meantime, feel free to reach us at
      <a href="mailto:connect@logisticsnow.in" style="color: #393185;">connect@logisticsnow.in</a>.
    </p>
  </div>
  <p style="font-size: 12px; color: #999; margin-top: 16px;">© LoRRI — LogisticsNow</p>
</body>
</html>`.trim();

// --- New ScreenZero User: internal team notification ---
export const buildNewUserInternalContent = ({ email, number }) => `
<h4>Hello,</br></br>
${email} has visited the LoRRI Home!
<div>
  Email ID is: ${email}<br/>
  Phone Number is: ${number}
</div></br>
</br>Thanks</h4>`.trim();

// --- New ScreenZero User: user confirmation ---
export const buildNewUserUserContent = ({ email }) => `
<!DOCTYPE html>
<html>
<body style="font-family: Arial, sans-serif; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
  <div style="background-color: #393185; padding: 20px 24px; border-radius: 6px 6px 0 0;">
    <h2 style="color: #ffffff; margin: 0; font-size: 20px;">Welcome to ScreenZero — LoRRI</h2>
  </div>
  <div style="border: 1px solid #e0e0e0; border-top: none; border-radius: 0 0 6px 6px; padding: 24px;">
    <p style="font-size: 15px; margin: 0 0 16px;">Hi,</p>
    <p style="font-size: 15px; margin: 0 0 16px;">
      You're now registered on <strong>LoRRI</strong>. Our team will reach out to you shortly.
    </p>
    <p style="font-size: 14px; color: #555; margin: 0 0 16px;">
      Your registered email: <strong>${email}</strong>
    </p>
    <p style="font-size: 14px; color: #555; margin: 0;">
      For any queries, write to us at
      <a href="mailto:connect@logisticsnow.in" style="color: #393185;">connect@logisticsnow.in</a>.
    </p>
  </div>
  <p style="font-size: 12px; color: #999; margin-top: 16px;">© LoRRI — LogisticsNow</p>
</body>
</html>`.trim();
